module.exports = __webpack_public_path__ + "img/discovery.d97752cc.svg";